import { format, getDate } from 'date-fns';

import {
  type AppointmentDate,
  type TimeSlot,
} from '@service-initiation/tech-care-data-access-tech-care-services';

export const formatHour = (date?: string) =>
  date
    ? `${format(new Date(date), 'E')}, ${format(new Date(date), 'LLLL d')}`
    : undefined;

export const formatTime = (slot?: TimeSlot) =>
  slot
    ? `${slot.start.replace(':00', '').toLowerCase()}-${slot.end
        ?.replace(':00', '')
        .toLowerCase()}`
    : undefined;

export const getTodaysScheduleFormatDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = ('0' + (today.getMonth() + 1)).slice(-2);
  const date = ('0' + today.getDate()).slice(-2);
  return `${year}/${month}/${date}`;
};

export const isDisabledAppointment = (appointment: AppointmentDate): boolean =>
  appointment.isDisabled || !appointment.availableTimes.length;

export const getFormattedDate = (date: Date) => {
  return {
    day: getDate(date),
    month: format(date, 'LLLL'),
    weekday: format(date, 'EEEE'),
  };
};
